import SearchMyPoints from "./SearchMyPoints";

const CustomerPointsLookup = () => {
  return (
    <div className="bg-gradient-hero min-h-[calc(100vh-4rem)]">
      {/* Main Content Section */}
      <section className="py-12">
        <div className="container max-w-screen-xl px-4">
          <div className="text-center space-y-4 mb-12">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
              Consulta tus{" "}
              <span className="bg-gradient-primary bg-clip-text text-transparent">
                Puntos de Lealtad
              </span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Ingresa tu número de teléfono para ver tus puntos acumulados y las recompensas disponibles
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            {/* Search Component in Card */}
            <div className="bg-white rounded-lg shadow-medium border-0 p-8">
              <SearchMyPoints />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomerPointsLookup;
